// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"42":"module-colorSwitchContainer","383":"module-cookieBanner","460":"module-lottie-player","471":"module-isotope","651":"module-bgImage","994":"module-tabMenu"}[chunkId] || chunkId) + ".js";
};